var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15265_33608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5281 7.35382L13.05 6.753L10.4767 0.777665C10.2966 0.359268 9.70335 0.359268 9.5232 0.777665L6.94996 6.75304L0.471885 7.35382C0.0182922 7.39589 -0.165028 7.96007 0.177198 8.2607L5.06492 12.5545L3.63453 18.9012C3.53438 19.3456 4.0143 19.6943 4.40598 19.4617L9.99999 16.1401L15.594 19.4617C15.9857 19.6943 16.4656 19.3456 16.3655 18.9012L14.9351 12.5545L19.8228 8.2607C20.165 7.96007 19.9817 7.39589 19.5281 7.35382Z",
    fill: "#FFC850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4768 0.777666C10.2966 0.359268 9.70337 0.359268 9.52321 0.777666L6.94997 6.75306L0.471886 7.35384C0.0182923 7.39591 -0.165028 7.96009 0.177199 8.26071L5.06493 12.5545L3.63454 18.9013C3.53439 19.3456 4.01431 19.6943 4.40599 19.4617L5.65454 18.7204C5.82735 11.607 9.13243 6.59778 11.7492 3.7322L10.4768 0.777666Z",
    fill: "#FABB00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15265_33608)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.14062,
    y: -23.9639,
    width: 2,
    height: 46,
    transform: "rotate(26.245 2.14062 -23.9639)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15265_33608",
    x: -22.2012,
    y: -27.9639,
    width: 30.1348,
    height: 50.1423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_15265_33608"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15265_33608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.e7272e408ef973211e9ccf0d51e287e4.svg";
export { ForwardRef as ReactComponent };